export type UserType = "candidate" | "selfService";

export const determineUserType = (): UserType => {
  const subdomain = window.location.hostname.split(".")[0];
  if (subdomain.includes("registration")) {
    return "selfService";
  } else if (subdomain.includes("signup")) {
    return "candidate";
  } else {
    if (subdomain !== 'localhost') {
      console.error("Invalid subdomain");
    }
    return "candidate"; // Default or error handling
  }
};
